import React from "react";
import { AddClientDetailsScreenWithBookingData } from "~/features/book-appointment/AddClientDetailsScreen";

const Component = () => {
  return <AddClientDetailsScreenWithBookingData />;
};

export default Component;
